<div class="body flex-grow-1 px-3">
  <div class="container-fluid">
      <div class="row">
          <div class="d-flex justify-content-end p-4">
              <button class="btn btn-sm btn-primary d-flex align-items-center" (click)="redirectToUser()">
                <i class="cil-arrow-left custom-icon pe-1"></i>
                Back
              </button>
            </div>
          <div class="col-md-12 col-sm-12 col-12">
              <div class="card mb-4">
                  <div class="card-body">
                      <div class="row g-3">
                          <div class="col">
                              <label class="form-label" for="exampleFormControlTextarea1">Fiat Amount</label>
                          </div>
                          <div class="col">
                              <label class="form-label" for="exampleFormControlTextarea1">
                                  {{ withdrawData.fiatAmount }}</label>
                          </div>
                      </div>
                      <br />
                      <form class="">
                          <div class="row g-3">
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">Coin Current Price
                                      </label>
                              </div>
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">{{ withdrawData.coinCurrentPrice
                                      }}</label>
                              </div>
                          </div>
                          <br />
                          <div class="row g-3">
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">Total Amount</label>
                              </div>
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">
                                      {{withdrawData.coinValue}}
                                  </label>
                              </div>
                          </div>
                          <br />
                          <div class="row g-3" *ngIf="withdrawData?.type == 'token'">
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">Coin Value</label>
                              </div>
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">
                                      {{withdrawData.coinValue}}
                                  </label>
                              </div>
                          </div>
                          <br />
                          <div class="row g-3">
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">Reward</label>
                              </div>
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">
                                      {{withdrawData.reward}}
                                  </label>
                              </div>
                          </div>
                          <br />
                          <div class="row g-3">
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">Total Coin value
                                      </label>
                              </div>
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">
                                      {{withdrawData.totalCoinvalue}}
                                  </label>
                              </div>
                          </div>
                          <br />

                          <div class="row g-3">
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">Admin Approved On </label>
                              </div>
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">{{ withdrawData.adminActionDate | date : "medium"  }}</label>
                              </div>
                          </div>
                          <br />


                          <div class="row g-3" *ngIf="withdrawData?.withdrawStatus == 'requested'">
                              <div class="col">
                                  <label class="form-label" for="exampleFormControlTextarea1">Action</label>
                              </div>
                              <div class="col">
                                  <button class="btn btn-primary" type="button" disabled
                                      *ngIf="loader; else actionBtn">
                                      <span class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                      Loading...
                                  </button>
                                  <ng-template #actionBtn>
                                      <button type="button" class="btn btn-sm btn-secondary me-2"
                                          (click)="approveCoinWithdraw()" *ngIf="withdrawData?.withdrawStatus == 'requested'">Approve</button>
                                      <button type="button" class="btn btn-sm btn-danger"
                                          (click)="rejectCoinWithdraw()" *ngIf="withdrawData?.withdrawStatus == 'requested'">Reject</button>
                                  </ng-template>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
